import styled from 'styled-components';
import { Stack } from 'components/Stack';
import {
  DescriptionHyperLink,
  DescriptionColoredButton,
  DescriptionRow,
  ItemBox,
  TruncatedTitle,
} from '../ItemCommons/CommonItem.styles';

const Wrapper = styled(ItemBox)<{ isExpandDescription: boolean }>`
  width: 100%;
  display: flex;
  padding: 12px;
  height: ${({ isExpandDescription }) =>
    isExpandDescription ? 'auto' : '104px'};
  max-height: ${({ isExpandDescription }) =>
    isExpandDescription ? '244px' : 'none'};
`;

const ThumbnailSection = styled.div`
  margin-right: 16px;
`;

const InfoSection = styled(Stack).attrs({
  align: 'flex-start',
  justify: 'center',
  direction: 'column',
})`
  width: 100%;
`;

const TruncateTitleSection = styled.div`
  flex: 1;
  padding-right: 5px;
`;

const ListItemTitle = styled(TruncatedTitle)`
  min-width: 300px;
  padding-right: 32px;
`;

const DetailsSection = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const CenterSection = styled.div`
  display: flex;
  flex: 0.8;
  justify-content: space-between;
`;

const TruncateTextSection = styled.div<{ lines: number }>`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: ${({ lines }) => lines};
  -webkit-box-orient: vertical;
`;

const PriceQtyRow = styled(DescriptionRow)`
  width: 160px;
`;

const DescriptionSection = styled(Stack)`
  margin-top: 16px;
`;

const ItemURL = styled(DescriptionHyperLink)`
  margin-top: 16px;
  display: block;
`;

const ViewDetailsSection = styled.div`
  display: flex;
  justify-content: flex-end;
  flex: 0.7;
`;

const ItemViewDetails = styled(DescriptionColoredButton)`
  width: 144px;
  text-align: right;
`;

export {
  Wrapper,
  DetailsSection,
  ItemURL,
  ItemViewDetails,
  DescriptionSection,
  InfoSection,
  CenterSection,
  PriceQtyRow,
  ViewDetailsSection,
  TruncateTitleSection,
  ThumbnailSection,
  ListItemTitle,
  TruncateTextSection,
};
